import { defineAction } from 'redux-define';

const CANCELLED = 'CANCELLED';
const ERROR = 'ERROR';
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';
const CLEAR = 'CLEAR';
const SENT = 'SENT';

export const LOAD_USER_LOGIN = defineAction(
  'LOAD_USER_LOGIN',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR, SENT],
  'claro/LoginSSO',
);

export const LOAD_USER_LOGIN_SSO = defineAction(
  'LOAD_USER_LOGIN_SSO',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR, SENT],
  'claro/LoginSSO',
);

export const LOAD_USER_VALID_PHONE = defineAction(
  'LOAD_USER_VALID_PHONE',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR, SENT],
  'claro/LoginSSO',
);

export const LOAD_USER_PINCODE = defineAction(
  'LOAD_USER_PINCODE',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR, SENT],
  'claro/LoginSSO',
);

export const LOAD_USER_REGISTER = defineAction(
  'LOAD_USER_REGISTER',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);

export const LOAD_USER_IS_LOGGEDIN = defineAction(
  'LOAD_USER_IS_LOGGEDIN',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);

export const LOAD_USER_MODIFY = defineAction(
  'LOAD_USER_MODIFY',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);

export const LOAD_USER_AUTH_HBO_SSO = defineAction(
  'LOAD_USER_AUTH_HBO_SSO',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);

export const LOAD_USER_AUTH_TOOLBOX = defineAction(
  'LOAD_USER_AUTH_TOOLBOX',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);

export const LOAD_USER_FACEBOOK = defineAction(
  'LOAD_USER_FACEBOOK',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/LoginSSO',
);
